import { Box, Grid2, Typography } from '@mui/material';

import { ColorPicker } from 'src/components/NodeSaleForm/ColorPicker';
import { colors } from 'src/global/styles/colors';
import { useTheme } from 'src/provider/ThemeCustomizationProvider';

import { SectionAccordion } from './SectionAccordion';

export function ThemeColor() {
  const { theme, updateTheme } = useTheme();
  return (
    <Box padding={'12px 24px 24px 24px'} borderBottom={`1px solid ${colors.neutral015}`}>
      <SectionAccordion
        title='Color'
        bodyContent={
          <Box width={'100%'}>
            <Grid2 container width={'100%'} spacing={3}>
              <Grid2 size={6}>
                <Typography fontSize={'14px'} fontWeight={500} lineHeight={'20px'} sx={{ color: 'white' }}>
                  Primary Color
                </Typography>
                <Typography
                  marginTop={1}
                  fontSize={'12px'}
                  fontWeight={400}
                  lineHeight={'16px'}
                  sx={{ color: colors.neutral90 }}>
                  Primary Color
                </Typography>
                <Box width={'100%'} marginTop={2}>
                  <ColorPicker
                    color={theme.theme.bgColorButton.primary}
                    onColorChange={color => {
                      updateTheme({
                        ...theme,
                        theme: { ...theme.theme, bgColorButton: { ...theme.theme.bgColorButton, primary: color } },
                      });
                    }}
                    opacity={theme.theme.bgColorButton.primaryOpacity}
                    onOpacityChange={opacity => {
                      updateTheme({
                        ...theme,
                        theme: {
                          ...theme.theme,
                          bgColorButton: { ...theme.theme.bgColorButton, primaryOpacity: opacity / 100 },
                        },
                      });
                    }}
                  />
                </Box>
              </Grid2>
              <Grid2 size={6}>
                <Typography fontSize={'14px'} fontWeight={500} lineHeight={'20px'} sx={{ color: 'white' }}>
                  Secondary Color
                </Typography>
                <Typography
                  marginTop={1}
                  fontSize={'12px'}
                  fontWeight={400}
                  lineHeight={'16px'}
                  sx={{ color: colors.neutral90 }}>
                  Secondary Color
                </Typography>
                <Box width={'100%'} marginTop={2}>
                  <ColorPicker
                    color={theme.theme.bgColorButton.secondary}
                    onColorChange={color => {
                      updateTheme({
                        ...theme,
                        theme: { ...theme.theme, bgColorButton: { ...theme.theme.bgColorButton, secondary: color } },
                      });
                    }}
                    opacity={theme.theme.bgColorButton.secondaryOpacity}
                    onOpacityChange={opacity => {
                      updateTheme({
                        ...theme,
                        theme: {
                          ...theme.theme,
                          bgColorButton: { ...theme.theme.bgColorButton, secondaryOpacity: opacity / 100 },
                        },
                      });
                    }}
                  />
                </Box>
              </Grid2>
            </Grid2>
          </Box>
        }
      />
    </Box>
  );
}
